export default __webpack_public_path__ + "59f6d056fc748734afd3f80344452eab.svg";